import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleRequest } from "../../helpers/handleAsync";
import addressService from "../../services/addressService";
import provinceService from "../../services/provinceService";

const getProvinceList = createAsyncThunk(
    'address/getDataProvince',
    async () => {
        const [res, err] = await handleRequest(provinceService.getProvinces());
        if (!res || err) {
            throw new Error('Unknow error');
        }
        return res.data;
    }
)
const getDistrictList = createAsyncThunk(
    'address/getDataDistrict',
    async (provinceId: string) => {
        const [res, err] = await handleRequest(addressService.getDistricts(provinceId));
        if (!res || err) {
            throw new Error('Unknow error');
        }
        return res.data;
    }
)
const getWardList = createAsyncThunk(
    'address/getDataWard',
    
    async (districtId: string) => {
        const [res, err] = await handleRequest(addressService.getWards(districtId));
        if (!res || err) {
            throw new Error('Unknow error');
        }
        return res.data;
    }
)
export const addressPrvSliceActions = { getProvinceList, getDistrictList, getWardList };